export default __webpack_public_path__ + "static/media/mig_assist.ee39d581.svg";